import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import ReactLink from '@client/components/reactLink/ReactLink';
import { strings } from '@client/localization/Localization';
import indicators from '@client/shared/js/indicators';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './sideMenuItem.scss';

class SideMenuItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      categoriesMenuIsOpen: false,
    };
  }

  getSideMenuItemClassname() {
    return classNames({
      [styles.sideMenuItem]: true,
      [this.props.className]: this.props.className,
      [themeStyles.hideOnDesktop]: this.props.onlyMobile,
    });
  }

  toggleCategoriesMenu = () => {
    const menuToggle = this.state.categoriesMenuIsOpen;
    this.setState({
      categoriesMenuIsOpen: !menuToggle,
    });
  };

  render() {
    const { location, route, onCloseClick, title, subEntries } = this.props;
    const { categoriesMenuIsOpen } = this.state;

    let currentUrl = null;
    if (location) {
      currentUrl = location.pathname;
    }

    return (
      <div className={this.getSideMenuItemClassname()}>
        <div
          className={
            currentUrl === route
              ? `${styles.focused} ${styles.itemBox}`
              : styles.itemBox
          }
        >
          {title === strings.categories ? (
            <div className={styles.categoriesWrapper}>
              <div
                className={styles.categoriesBox}
                onClick={this.toggleCategoriesMenu}
              >
                <div
                  className={`${themeStyles.sideMenuItem} ${styles.categoriesText}`}
                >
                  {title}
                  <img
                    className={styles.arrowIcon}
                    src={indicators.icon_arrowdown}
                    alt="factuals arrow down"
                  />
                </div>
              </div>
              {categoriesMenuIsOpen && (
                <div className={styles.expandableMenu}>
                  {subEntries &&
                    subEntries[strings.categories].map((category, index) => {
                      return (
                        <ReactLink
                          to={category.route}
                          key={index}
                          className={`${themeStyles.sideMenuItem} ${styles.expandableMenuItem}`}
                          onClick={onCloseClick}
                        >
                          {category.name}
                        </ReactLink>
                      );
                    })}
                </div>
              )}
            </div>
          ) : (
            <ReactLink
              to={route}
              className={styles.title}
              onClick={onCloseClick}
            >
              <div className={`${themeStyles.sideMenuItem}`}>{title}</div>
            </ReactLink>
          )}
        </div>
      </div>
    );
  }
}

SideMenuItem.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  item: PropTypes.object,
  route: PropTypes.string,
  location: PropTypes.object,
  onCloseClick: PropTypes.func,
  onlyMobile: PropTypes.bool,
  subEntries: PropTypes.object,
};

export default SideMenuItem;
